// Things which are considered in create-style.js should go in this enum
export const StyleProperty = {
  LINE_START_DECORATION: 'lineStartDecoration',
  LINE_END_DECORATION: 'lineEndDecoration',
  FOREGROUND_COLOR: 'foregroundColor',
  BACKGROUND_COLOR: 'backgroundColor',
  LINE_WIDTH: 'lineWidth',
  LINE_STYLE: 'lineStyle',
  LINE_SIGNATURE_TYPE: 'lineSignatureType',
  POINT_SIGNATURE_TYPE: 'pointSignatureType',
  IMAGE: 'image',
  IMAGE_AS_BASE64: 'imageAsBase64',
  SIGNATURE_SIZE: 'signatureSize',
  SYMBOL_SIZE: 'symbolSize',
  BORDER_COLOR: 'borderColor',
  FILL_STYLE: 'fillStyle',
  FILL_SIGNATURE_TYPE: 'fillSignatureType',
  ROTATION: 'rotation',
  BACKGROUND_VISIBLE: 'backgroundVisible',
  ANCHOR: 'anchor',
  ITALIC: 'italic',
  BOLD: 'bold',
  FONT_SIZE: 'fontSize',
  FONT_FAMILY: 'fontFamily',
  TEXT: 'text',
  OPACITY: 'opacity',
  Z_INDEX: 'zIndex',
  FOREGROUND_COLOR_OPACITY: 'foregroundColorOpacity',
  LINE_WIDTH_UNIT: 'lineWidthUnit'
} as const;

export type StyleProperty = typeof StyleProperty[keyof typeof StyleProperty];

export const FillStyle = {
  HORIZONTAL: 'HORIZONTAL',
  HORIZONTAL_WIDE: 'HORIZONTAL_WIDE',
  HORIZONTAL_NARROW: 'HORIZONTAL_NARROW',
  SOLID: 'SOLID',
  TRANSPARENT: 'TRANSPARENT',
  VERTICAL: 'VERTICAL',
  VERTICAL_WIDE: 'VERTICAL_WIDE',
  VERTICAL_NARROW: 'VERTICAL_NARROW',
  DIAGONAL_UP: 'DIAGONAL_UP',
  DIAGONAL_UP_WIDE: 'DIAGONAL_UP_WIDE',
  DIAGONAL_UP_NARROW: 'DIAGONAL_UP_NARROW',
  DIAGONAL_DOWN: 'DIAGONAL_DOWN',
  DIAGONAL_DOWN_WIDE: 'DIAGONAL_DOWN_WIDE',
  DIAGONAL_DOWN_NARROW: 'DIAGONAL_DOWN_NARROW',
  CROSS: 'CROSS',
  CROSS_WIDE: 'CROSS_WIDE',
  CROSS_NARROW: 'CROSS_NARROW',
  DIAGONAL_CROSS: 'DIAGONAL_CROSS',
  DIAGONAL_CROSS_WIDE: 'DIAGONAL_CROSS_WIDE',
  DIAGONAL_CROSS_NARROW: 'DIAGONAL_CROSS_NARROW',
  GRAY_WIDE: 'GRAY_WIDE',
  LIGHT_GRAY: 'LIGHT_GRAY',
  GRAY: 'GRAY',
  DARK_GRAY: 'DARK_GRAY'
} as const;

export type FillStyle = keyof typeof FillStyle;

export const FillSignatureType = {
  NORMAL: 'normal',
  IMAGED: 'imaged'
} as const;

export type FillSignatureType = typeof FillSignatureType[keyof typeof FillSignatureType];

export const LineDecoration = {
  NONE: 'None',
  ARROW: 'Arrow',
  FILLED_ARROW: 'Filled Arrow',
  CROSSBAR: 'Crossbar'
} as const;

export type LineDecoration = typeof LineDecoration[keyof typeof LineDecoration];

export const PointSignatureType = {
  CIRCLE: 'Circle',
  DIAMOND: 'Diamond',
  TRIANGLE: 'Triangle',
  SQUARE: 'Square',
  ROUNDED_SQUARE: 'RoundedSquare',
  IMAGE: 'Image',
  CHARACTER: 'Character'
} as const;

export type PointSignatureType = typeof PointSignatureType[keyof typeof PointSignatureType];

export const LineSignatureType = {
  NORMAL: 'normal',
  IMAGED: 'imaged'
} as const;

export type LineSignatureType = typeof LineSignatureType[keyof typeof LineSignatureType];

export const AnchorType = {
  NORTH_WEST: [ 'top', 'left' ],
  NORTH: [ 'top', 'center' ],
  NORTH_EAST: [ 'top', 'right' ],
  WEST: [ 'alphabetic', 'left' ],
  CENTER: [ 'alphabetic', 'center' ],
  EAST: [ 'alphabetic', 'right' ],
  SOUTH_WEST: [ 'bottom', 'left' ],
  SOUTH: [ 'bottom', 'center' ],
  SOUTH_EAST: [ 'bottom', 'right' ]
} as const;

export type AnchorType = keyof typeof AnchorType;

export const MeasureUnit = {
  METRIC: 'metric',
  IMPERIAL: 'imperial'
} as const;

export type MeasureUnit = keyof typeof MeasureUnit;
